import HomeHeroCard from "@/components/homeHeroSection";
import {HERO_CONSTANTS} from "./constants";

const Hero = () => {
  return (
    <HomeHeroCard
      title={HERO_CONSTANTS.title}
      desc={HERO_CONSTANTS.desc}
      button={HERO_CONSTANTS.button}
      image={HERO_CONSTANTS.image.src}
    />
  );
};

export default Hero;
